module.exports = __webpack_public_path__ + "img/image-modal-on-process.973e1613.svg";